<template>
    <svg width="24" height="22" viewBox="0 0 24 22" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path class="navbar_hoverEffect" d="M23 17C23 14.5 21.5 11 17.5 9"  stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        <path class="navbar_hoverEffect" d="M21.5 18C22.0926 18 23 17.5067 23 17"  stroke-width="2" stroke-linecap="round"/>
        <path class="navbar_hoverEffect" d="M17.5 9C17.9982 9 18.4907 8.89364 18.9445 8.68802C19.3983 8.48241 19.8029 8.18228 20.1314 7.80771C20.4599 7.43314 20.7047 6.99275 20.8493 6.516C20.9939 6.03924 21.0351 5.5371 20.9701 5.04316C20.905 4.54921 20.7353 4.07484 20.4722 3.65176C20.2091 3.22868 19.8587 2.86665 19.4445 2.58986C19.0303 2.31307 18.5617 2.1279 18.0701 2.04675C17.5786 1.96559 17.0754 1.99031 16.5941 2.11926"  stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        <path class="navbar_hoverEffect_second" d="M18 18C18 20.0301 14.4719 20.5181 12.9846 20.745C11.8853 20.9128 10.7005 21 9.5 21C8.29946 21 7.1147 20.9128 6.01537 20.745C4.52807 20.5181 1 20.0301 1 18"  stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        <path class="navbar_hoverEffect_second" d="M1 18C1 16.967 1.21302 15.9406 1.63062 14.9785C2.04841 14.0158 2.66435 13.133 3.44928 12.3838C4.23443 11.6345 5.17238 11.0347 6.21202 10.6237C7.25171 10.2127 8.36925 10 9.5 10C10.6307 10 11.7483 10.2127 12.788 10.6237C13.8276 11.0347 14.7656 11.6345 15.5507 12.3838C16.3357 13.133 16.9516 14.0158 17.3694 14.9785C17.787 15.9406 18 16.967 18 18" stroke-width="2" stroke-linecap="round"/>
        <circle class="navbar_hoverEffect_second" cx="9.5" cy="5.5" r="4.5"  stroke-width="2"/>
    </svg>
</template>

<script>
export default {
  name: 'FriendsIcon'
}
</script>

<style scoped>
path {
    stroke: var(--nav-menu-new-icon);
}
circle {
    stroke: var(--nav-menu-new-icon);
}
</style>
